// extracted by mini-css-extract-plugin
export default {"jsonTable":"json_jsonTable__SLfyR"};